import { render } from "./CustomBids.vue?vue&type=template&id=5f3d785f&ts=true&lang=pug"
import script from "./CustomBids.vue?vue&type=script&lang=ts"
export * from "./CustomBids.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__